

































































































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
// import AddNewUser from "./component/addNewUserV2.vue";
const AddNewUser = () => import("./component/addNewUserV2.vue");
import { timeFormat } from "@/utils/index";
import { downloadFile } from "@/utils/index";
import { OutSourceRangeEnum, TwoFactAuthRangeEnum } from "@/enum/index";
import { client, authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import {
  SearchUserReq,
  UpdateUserReq,
  DeleteUserReq,
  CreateUserReq,
  GetUserListReq,
  UpdateUserStatusReq,
} from "@/pbjs/external/user/user_pb";
import { UserCommon, Meta } from "@/pbjs/xcommon/user_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { errorMsg, setCommon, setPage } from "@/utils/request";
import { pagnition } from "@/utils/commonConfig";

interface User {
  prePassword?: String;
  id?: Number;
  employeeId?: String;
  email: String;
  name?: String;
  role: String;
  check: String;
  password: String;
  type: number | null;
  company?: any;
}

@Component({
  name: "system",
  components: { AddNewUser },
})
export default class UserManagement extends Vue {
  @Provide() private userData: any = [];
  @Provide() private user: User = {
    email: "",
    role: "",
    check: "1",
    password: "",
    type: null,
  };
  @Provide() private isShowAddDialog: boolean = false;
  @Provide() private isNew: boolean = true;
  @Provide() private inputName: string = "";
  @Provide() private inputEmail: string = "";
  @Provide() private roleValue: string = "";
  @Provide() private roleOptions: any = [];
  @Provide() private nationValue: string = "";
  @Provide() private nationOptions: any = [{ value: "1", label: "1" }];
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private googleVerifyText: string = "启用谷歌验证";
  @Provide() private userid: number | null = null;
  @Provide() private issearchUserDone: boolean = false;
  @Provide() private isExportFormActionDone: boolean = false;
  @Provide() private loginTimeRange: any = [];
  @Provide() private pagnition: any = pagnition;
  @Provide() private userStatus: number | null = null;
  @Provide() private twoFactAuthRange: number | null =
    TwoFactAuthRangeEnum.TWO_FACT_AUTH_RANGE_ALL;
  @Provide() private outSourceRange: number | null =
    OutSourceRangeEnum.OUT_SOURCE_RANGE_ALL;
  @Provide() private searchUserId: number | null = null;
  @Provide() private searchStaffId: string | null = null;
  // 用户状态
  @Provide() private userStatusOptions: any = [];
  // 二次验证选项
  @Provide() private TwoFactAuthRangeEnumOptions: any = Object.entries(
    TwoFactAuthRangeEnum
  )
    .slice(1)
    .map((item: any, index: number) => {
      switch (index) {
        case 0:
          item[2] = "ticketLgy.Di";
          break;
        case 1:
          item[2] = "ticketLgy.Active";
          break;
        case 2:
          item[2] = "ticketLgy.All";
          break;
      }
      return item;
    });
  // 用户类型
  @Provide() private OutSourceRangeEnum: any = Object.entries(OutSourceRangeEnum)
    .slice(1)
    .map((item: any, index: number) => {
      switch (index) {
        case 0:
          item[2] = "ticketLgy.All";
          break;
        case 1:
          item[2] = "ticketLgy.LocalCollection";
          break;
        case 2:
          item[2] = "ticketLgy.Outsourcing";
          break;
        case 3:
          item[2] = "ticketLgy.PhoneVerify";
          break;
        case 4:
          item[2] = "robotFhb.robot";
          break;
        case 5:
          item[2] = "tipsWrh.noNormal";
          break;
        case 6:
          item[2] = "tipsWrh.admin";
          break;
        case 7:
          item[2] = "menuWrh.teleMarket";
          break;
      }
      return item;
    });
  private created() {
    // window.addEventListener('keyup', this.searchUserRequest);
    this.token = localStorage.getItem("token");
    this.getRoleListAPI();
    this.searchUserAction();
    this.getUserStatusOptions();
  }

  private mounted() {}

  // 获取用户状态下拉内容
  private getUserStatusOptions() {
    this.userStatusOptions = [
      { value: "1", label: this.$t("ticketLgy.Normal") },
      { value: "2", label: this.$t("ticketLgy.Block") },
      { value: "3", label: this.$t("ticketLgy.Invalid") },
    ];
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    // this.searchUser();
    this.searchUserRequest();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      // this.searchUser();
      this.searchUserRequest();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    // this.searchUser();
    this.searchUserRequest();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    // this.searchUser();
    this.searchUserRequest();
  }
  // 更新用户状态
  private updateUserStatusAPI(status: any, id: any) {
    let self = this;
    let request: any = new UpdateUserStatusReq();
    request.setCommonin(setCommon());
    request.setStatus(status);
    request.setUserid(id);
    client.updateUserStatus(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.code == 0) {
          this.isShowAddDialog = false;
          this.$message({
            message: `${this.$t("ticketLgy.Success")}`,
            type: "success",
          });
          // self.searchUser();
          self.searchUserRequest();
        } else {
          this.$message.error(data.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getRoleListAPI() {
    let request: any = setCommon();
    authorClient.listUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          if (data.usergroupinfosList) {
            this.roleOptions = data.usergroupinfosList;
          }
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private inputIDFuc() {
    !/^[0-9]+$/.test("" + this.searchUserId) &&
      this.$message({
        type: "error",
        message: "pls input number type",
      });
    return /^[0-9]+$/.test("" + this.searchUserId);
  }
  // 搜索操作
  private searchUserAction() {
    this.pageIndex = 1;
    // this.searchUser();
    this.searchUserRequest();
  }
  // 处理搜索用户的参数
  private dwGetUserListFuc() {
    // attendancetimefrom?: string;
    // attendancetimeto?: string;
    let _arg: any = {
      inputName: this.inputName,
      inputEmail: this.inputEmail,
      roleValue: "" + this.roleValue,
      userStatus: this.userStatus || 4,
      twoFactAuthRange: this.twoFactAuthRange,
      outSourceRange: this.outSourceRange,
      searchStaffId: this.searchStaffId,
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
    };
    _arg.isCouldRequest = true;
    if (this.loginTimeRange && this.loginTimeRange.length > 0 && this.loginTimeRange[0]) {
      (_arg.attendancetimefrom = timeFormat(this.loginTimeRange[0])),
        (_arg.attendancetimeto = timeFormat(this.loginTimeRange[1]));
    }
    if (/^[0-9]+$/.test("" + this.searchUserId)) {
      _arg.userId = this.searchUserId ? +this.searchUserId : null;
    } else {
      _arg.isCouldRequest = false;
      _arg.errorText = "the ID param have to be number type";
    }
    return _arg;
  }
  private searchUserRequest() {
    const _arg = this.dwGetUserListFuc();
    if (this.searchUserId) {
      if (_arg.isCouldRequest) {
        this.dwSearchUserRequest(_arg);
      } else {
        this.$message({
          type: "error",
          message: _arg.errorText ? _arg.errorText : "param is wrong",
        });
      }
    } else {
      this.dwSearchUserRequest(_arg);
    }
  }
  // 导出
  private async exportExcel() {
    const { setGetUserListReq, exportExcelRequest }: any = await import(
      "@/request/getUserList"
    );
    let response = await exportExcelRequest.handleHttp(
      setGetUserListReq(this.dwGetUserListFuc()),
      this
    );
    this.isExportFormActionDone = response ? response.loading : false;
    if (response && response.right) {
      if (response.filechunk) {
        let bStr = atob(response.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/json",
        });
        downloadFile(blob, response.filename);
      } else {
        this.$message({
          type: "error",
          message: response.commonout.errmsg
            ? response.commonout.errmsg
            : response.commonout.message,
        });
      }
    }
  }
  //  搜索用户列表
  private async dwSearchUserRequest(_arg: any) {
    const { setGetUserListReq, getUserListRequest }: any = await import(
      "@/request/getUserList"
    );
    let res = await getUserListRequest.handleHttp(setGetUserListReq(_arg), null);
    this.issearchUserDone = res ? res.loading : false;
    if (res && res.right) {
      this.userData =
        res.userinfosList && res.userinfosList.length > 0
          ? this.addPropertyEdit(res.userinfosList)
          : [];
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  private searchUser() {
    this.issearchUserDone = true;
    let searchRequest: any = new GetUserListReq();
    searchRequest.setCommonin(setCommon());
    searchRequest.setPagein(setPage(this.pageIndex, this.pageSize));
    searchRequest.setName(this.inputName);
    searchRequest.setEmail(this.inputEmail);
    searchRequest.setUsergroup(this.roleValue + "");
    let userStatus = this.userStatus || 4;
    searchRequest.setUserstatusrange(userStatus);
    if (this.loginTimeRange && this.loginTimeRange.length > 0 && this.loginTimeRange[0]) {
      searchRequest.setAttendancetimefrom(timeFormat(this.loginTimeRange[0]));
      searchRequest.setAttendancetimeto(timeFormat(this.loginTimeRange[1]));
    }
    client.getUserList(searchRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          if (data.userinfosList) {
            this.pagerCount = data.pageout.total;
            this.userData = this.addPropertyEdit(data.userinfosList);
          }
        } else if (data.commonout.code == 102) {
          this.pagerCount = 0;
          this.userData = [];
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.issearchUserDone = false;
    });
  }

  private editUser(row: any) {
    this.user = {
      id: row.id,
      email: row.common.email,
      role: row.common.role,
      check: row.check,
      password: "",
      name: row.common.name,
      employeeId: row.employeeid,
      type: row.common.exectype,
      company: row.common.company,
    };
    this.isNew = false;
    this.isShowAddDialog = true;
  }

  private editUserAPI(user: User) {
    let self = this;
    let request: any = new UpdateUserReq();
    request.setCommonin(setCommon());
    request.setUserid(user.id);
    request.setOperatorid(this.userid);
    request.setEmployeeid(user.employeeId);
    request.setPassword(user.password);
    let common: any = new UserCommon();
    common.setEmail(user.email);
    common.setName(user.name);
    common.setUsergroup(user.role);
    common.setSecondaryverify(this.findCheck(user.check));
    request.setCommon(common);
    if (user.type === ExecType.EXEC_TYPE_URGE_OUTSOURCE) {
      request.setExectype(ExecType.EXEC_TYPE_URGE_OUTSOURCE);
      let meta: any = new Meta();
      meta.setId(user.company.id);
      meta.setName(user.company.name);
      request.setCompany(meta);
    } else if (user.type === ExecType.EXEC_TYPE_URGE_INTERNAL) {
      request.setExectype(ExecType.EXEC_TYPE_URGE_INTERNAL);
    } else if (user.type === ExecType.EXEC_TYPE_TEL_VERIFY) {
      request.setExectype(ExecType.EXEC_TYPE_TEL_VERIFY);
    } else if (user.type === ExecType.EXEC_TYPE_ROBOT) {
      request.setExectype(ExecType.EXEC_TYPE_ROBOT);
      let meta: any = new Meta();
      meta.setId(user.company.id);
      meta.setName(user.company.name);
      request.setCompany(meta);
    }else if (user.type === ExecType.EXEC_TYPE_PHONE_SALE) {
      request.setExectype(ExecType.EXEC_TYPE_PHONE_SALE);
    }else if (user.type === ExecType.EXEC_TYPE_ADMIN) {
      request.setExectype(ExecType.EXEC_TYPE_ADMIN);
    }else if(user.type === ExecType.EXEC_TYPE_TEMP){
       request.setExectype(ExecType.EXEC_TYPE_TEMP);
      let meta: any = new Meta();
      meta.setId(user.company.id);
      meta.setName(user.company.name);
      request.setCompany(meta);
    }

    client.updateUser(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.code == 0) {
          this.isShowAddDialog = false;
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          // self.searchUser();
          self.searchUserRequest();
        } else {
          this.$message.error(data.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private goDashboard(row: any) {
    let routeData = this.$router.resolve({
      path: "/Performance/dashboard",
      query: {
        uid: row.id,
      },
    });
    window.open(routeData.href, "_blank");
  }
  private deleteUser(row: any) {
    this.$confirm("Are you sure to delete", "", {
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    })
      .then(() => {
        this.deleteUserAPI(row);
      })
      .catch(() => {
      });
  }

  private deleteUserAPI(user: any) {
    let operateId = localStorage.getItem("userid");
    let deleteRequest: any = new DeleteUserReq();
    deleteRequest.setCommonin(setCommon());
    deleteRequest.setUserid(user.id);
    deleteRequest.setOperatorid("1234231");
    client.deleteUser(deleteRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          // this.searchUser();
          this.searchUserRequest();
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private addUser() {
    this.isNew = true;
    this.preCreateUserAPI();
  }

  //todo
  private addUserAPI(user: User) {
    let addRequest: any = new CreateUserReq();
    addRequest.setCommonin(setCommon());
    addRequest.setEmployeeid(user.employeeId);
    addRequest.setEmail(user.email);
    addRequest.setMobile("");
    addRequest.setName(user.name);
    addRequest.setUsergroup(user.role);
    addRequest.setPassword(user.password);
    addRequest.setSecondaryverify(this.findCheck(user.check));
    if (user.type === ExecType.EXEC_TYPE_URGE_OUTSOURCE) {
      addRequest.setExectype(ExecType.EXEC_TYPE_URGE_OUTSOURCE);
      let meta: any = new Meta();
      meta.setId(user.company.id);
      meta.setName(user.company.name);
      addRequest.setCompany(meta);
    } else if (user.type === ExecType.EXEC_TYPE_URGE_INTERNAL) {
      addRequest.setExectype(ExecType.EXEC_TYPE_URGE_INTERNAL);
    } else if (user.type === ExecType.EXEC_TYPE_TEL_VERIFY) {
      addRequest.setExectype(ExecType.EXEC_TYPE_TEL_VERIFY);
    } else if (user.type === ExecType.EXEC_TYPE_ROBOT) {
      addRequest.setExectype(ExecType.EXEC_TYPE_ROBOT);
    }else if (user.type === ExecType.EXEC_TYPE_PHONE_SALE) {
      addRequest.setExectype(ExecType.EXEC_TYPE_PHONE_SALE);
    }else if(user.type === ExecType.EXEC_TYPE_TEMP){
       addRequest.setExectype(ExecType.EXEC_TYPE_TEMP);
    }else if(user.type === ExecType.EXEC_TYPE_ADMIN){
      addRequest.setExectype(ExecType.EXEC_TYPE_ADMIN);
    }
    client.createUser(addRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.isShowAddDialog = false;
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.searchUserAction();
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private returnNewUser(user: any) {
    // this.user = user;
    if (this.isNew) {
      this.addUserAPI(user);
    } else {
      this.editUserAPI(user);
    }
  }

  private returnIsShow(isShow: boolean) {
    this.isShowAddDialog = isShow;
  }

  private findCheck(check: any) {
    if (check === this.$t("authority.Enable")) {
      return 1;
    } else {
      return 0;
    }
  }

  private addPropertyEdit(data: any) {
    data.forEach((item: any) => {
      let time = timeFormat(item.operatetime);
      item.operatetime = time;
      item.attendanceat = timeFormat(item.attendanceat);
      item.lastlogintime = timeFormat(item.lastlogintime);
      item.registertime = timeFormat(item.registertime);
      if (item.common.secondaryverify) {
        item.check = this.$t("authority.Enable");
      } else {
        item.check = this.$t("authority.Disable");
      }
      if (item.common.exectype === ExecType.EXEC_TYPE_URGE_INTERNAL) {
        item.common.typeName = this.$t("Local Collection");
        //   item.common.company = "pcfinancial";
      } else if (item.common.exectype === ExecType.EXEC_TYPE_URGE_OUTSOURCE) {
        item.common.typeName = this.$t("Outsourcing");
      } else if (item.common.exectype === ExecType.EXEC_TYPE_TEL_VERIFY) {
        item.common.typeName = this.$t("Phone Verify");
      } else if (item.common.exectype === ExecType.EXEC_TYPE_ROBOT) {
        item.common.typeName = this.$t("robotFhb.robot");
      } else if (item.common.exectype === ExecType.EXEC_TYPE_PHONE_SALE) {
        item.common.typeName = this.$t("menuWrh.teleMarket");
      }else if(item.common.exectype === ExecType.EXEC_TYPE_TEMP){
        item.common.typeName = this.$t("tipsWrh.noNormal");
      }else if(item.common.exectype === ExecType.EXEC_TYPE_ADMIN){
        item.common.typeName = this.$t("tipsWrh.admin");
      }else{
        item.common.typeName = "";

      }
    });
    return data;
  }

  private preCreateUserAPI() {
    let addRequest: any = setCommon();
    client.preCreateUser(addRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.user = {
            email: "",
            role: "",
            check: "",
            password: data.defaultpassword,
            employeeId: "",
            name: "",
            prePassword: data.defaultpassword,
            type: 1,
            company: null,
          };
          this.isShowAddDialog = true;
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private async editAllUserInfo (row:any) {
    let rows = JSON.parse(JSON.stringify(row))
    rows.common = ''
    if(rows.archiveid === 0){
      // 说明该用户为新增
      localStorage.setItem('userType', 'add');
    } else {
      localStorage.setItem('userType', 'look');
    }
    localStorage.setItem('archiveid', row.archiveid);
    let common = JSON.stringify(row.common)
    rows.common = common
    this.$router.push({path:'/addPeopleInfo',query:rows})
  }
}
